import { render, staticRenderFns } from "./FeedsList.vue?vue&type=template&id=a506abd8&"
import script from "./FeedsList.vue?vue&type=script&lang=js&"
export * from "./FeedsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports